// High-order components must use the spreading operator
// to pass the props down to the real one.
/* eslint-disable react/jsx-props-no-spreading */
import { ComponentType, useLayoutEffect, useState } from 'react';

import breakpoints from '../themes/MainTheme/partials/breakpoints';

const defaultMediaQueries = {
  $mediaIsDesktop: false,
  $mediaIsDesktopL: false,
  $mediaIsDesktopM: false,
  $mediaIsDesktopS: false,
  $mediaIsDesktopXl: false,
  $mediaIsLandscape: false,
  $mediaIsLaptop: false,
  $mediaIsPhone: false,
  $mediaIsPortrait: false,
  $mediaIsTablet: false
};

export function withMediaQueries<T>(Component: ComponentType<T>) {
  return (props: T) => {
    const [mediaQueries, setMediaQueries] = useState(defaultMediaQueries);
    useLayoutEffect(() => {
      function updateSize() {
        const isPhone = window.innerWidth < breakpoints.tablet;
        const isTablet =
          window.innerWidth >= breakpoints.tablet &&
          window.innerWidth < breakpoints.desktopS;
        setMediaQueries({
          ...mediaQueries,
          $mediaIsDesktop: window.innerWidth >= breakpoints.desktopS,
          $mediaIsDesktopL:
            window.innerWidth >= breakpoints.desktopL &&
            window.innerWidth < breakpoints.desktopXl,
          $mediaIsDesktopM:
            window.innerWidth >= breakpoints.desktopM &&
            window.innerWidth < breakpoints.desktopL,
          $mediaIsDesktopS:
            window.innerWidth >= breakpoints.desktopS &&
            window.innerWidth < breakpoints.desktopM,
          $mediaIsDesktopXl: window.innerWidth >= breakpoints.desktopXl,
          $mediaIsLandscape: !window.matchMedia
            ? false
            : window.matchMedia('(orientation: landscape)').matches,
          $mediaIsPhone: isPhone,
          $mediaIsPortrait: !window.matchMedia
            ? false
            : window.matchMedia('(orientation: portrait)').matches,
          $mediaIsTablet: isTablet
        });
      }

      window.addEventListener('resize', updateSize);
      updateSize();

      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return <Component {...props} {...mediaQueries} />;
  };
}
